import { Route } from 'react-router-dom';
import CmsGlobal from '../pages/cms-global';
import { getValueByEnv } from '@/env';

/**
 * 三超CMS
 * 0620版本
 */
const InjectType = { iframe: 3, microapp: 2 };

const sanchaoCMS_URL = getValueByEnv({
  envDev: {
    sanchao: 'http://cicada-beta.local-pf.jd.com/floor-operation/sanchao/sanchao_activity_tool/project_info_input',
  },
  envBeta: {
    sanchao: 'http://cicada-beta.local-pf.jd.com/floor-operation/sanchao/sanchao_activity_tool/project_info_input',
  },
  envProd: {
    sanchao: 'https://cicada-pro.pf.jd.com/floor-operation/sanchao/sanchao_activity_tool/project_info_input',
  },
});

const sanchaoCmsRoutes = [
  <Route
    key="/materials/cms-global/:channelId/sanchao-cms"
    path="/materials/cms-global/:channelId/sanchao-cms"
    component={function () {
      return <CmsGlobal injectType={InjectType.iframe} title="三超CMS" url={sanchaoCMS_URL.sanchao} />;
    }}
  />,
];

export default sanchaoCmsRoutes;
